import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  TemplateRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import { Router } from '@angular/router';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { ConfirmationService } from 'primeng/primeng';
import { ToastrService } from 'ngx-toastr';
import { UploadService } from '../../../../../common/services/Upload.service';
import _ from 'lodash';
import { AgencyService } from '../../../qrcode/agencyListing/services/agency.service';

declare var $: any;
var that: any;

@Component({
  moduleId: module.id,
  selector: 'point_of_sale',
  templateUrl: './point_of_sale.component.html',
  styleUrls: ['../product.css'],
  providers: [ConfirmationService, EvsProductService],
})
@Injectable()
export class PointOfSaleComponent implements OnInit {
  modalRef: BsModalRef;
  @Input('idDetail') idDetail: any;
  @Output('backToList') backToList = new EventEmitter();
  listItem = [];
  listECommerce = [];
  @ViewChild("actionAgency") actionAgency: ModalDirective;
  @ViewChild('modalAddProduct') modalAddProduct;
  @Output() loadEventList = new EventEmitter<string>();

  total_stamp = 0;
  pageIndexStamp = 1;
  pageSizeStamp = 5;
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];
  queryStamp = {
    page: '',
    pageSize: '',
    productId: '',
    name: '',
    status: 1,
  } as any;
  formStamp = this.fb.group({
    code: null,
  });
  data_stamp = [];

  constructor(
    public productService: EvsProductService,
    private fb: FormBuilder,
    private translate: TranslateService,
    public router: Router,
    private toastr: ToastrService,
    public upload: UploadService,
  ) {
    that = this;
  }


  ngOnInit() {
    // this.fetch();
  }
  closeModal() {
    this.actionAgency.hide();
  }
  showModal(): void {
    this.actionAgency.show();
    this.list_id = [];
    this.listOfChecked = [];
    this.data_stamp = [];
    this.queryStamp = {};
    this.total_stamp = 0;
    this.pageIndexStamp = 1;
    this.pageSizeStamp = 5;
    this.formStamp.reset();
    this.fetch();
  }
  prePageStamp() {
    this.pageIndexStamp = this.pageIndexStamp - 1;
    this.fetch();
  }
  inputPageStamp(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStamp) {
      this.pageIndexStamp = page;
      this.fetch();
    }
  }
  lastPageStamp() {
    if (this.pageIndexStamp * this.pageSizeStamp < this.total_stamp) {
      this.pageIndexStamp = this.pageIndexStamp + 1;
      this.fetch();
    }
  }
  checkALl(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_stamp.map((item) => {
        this.listOfChecked[item.id] = true;
      });
      this.listIdChecked();
      return;
    }
    this.data_stamp.map((item) => {
      this.listOfChecked[item.id] = false;
      this.listIdChecked();
    });
  }
  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
    console.log('this.list_id', this.list_id)
  }
  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;
    this.listOfChecked[value] = checked;
    this.isCheckAll = this.data_stamp.every(
      (item) => this.listOfChecked[item.id]
    );

    this.listIdChecked();
  }
  refeshCheckAll() {
    if (this.data_stamp && this.data_stamp.length) {
      this.isCheckAll = this.data_stamp.every(
        (item) => this.listOfChecked[item.id]
      );
      return;
    }
    this.isCheckAll = false;
  }
  addProduct() {
    if (this.list_id.length == 0) {
      this.toastr.error(this.translate.instant('BAN_CHUA_CHON_DIEM_BAN'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return
    }
    this.modalAddProduct.showModal();
    this.closeModal()
  }
  fetch() {
    this.queryStamp.page = this.pageIndexStamp;
    this.queryStamp.pageSize = this.pageSizeStamp;
    this.queryStamp.orderBy = 'createdAt:desc';
    this.queryStamp.status = 1;
    this.productService
      .getProductStore(this.queryStamp)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.data_stamp = res.data.items;
            this.total_stamp = res.data.pagination.totalElements;
            this.refeshCheckAll();
            // this.loading_stamp = false;
            return;
          }
          this.data_stamp = [];
          this.total_stamp = 0;
          // this.loading_stamp = false;
        },
        (error) => {
          this.data_stamp = [];
          this.total_stamp = 0;
          // this.loading_stamp = false;
        }
      );
  }
  searchStamp() {
    this.pageIndexStamp = 1;
    this.queryStamp.name = this.formStamp.value.code;
    this.fetch();
  }
  resetStamp() {
    this.formStamp.reset();
    this.pageIndexStamp = 1;
    this.queryStamp.name = '';

    this.fetch();
  }
  reload($event) {
    this.loadEventList.emit($event)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product-setting/point_of_sale.component.ts